var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { EmbedVideoService } from '../common-theme/index';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var OurViewComponent = /** @class */ (function (_super) {
    __extends(OurViewComponent, _super);
    function OurViewComponent(injector, embedService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.embedService = embedService;
        _this.youtubeUrl = 'https://www.youtube.com/watch?v=XOLGCf9AEHg';
        return _this;
    }
    OurViewComponent.prototype.ngOnInit = function () {
        this.videoInnerHTML = this.embedService.embed(this.youtubeUrl);
        this.setTitle('Conceptul de la baza proiectului Romanescu Park Residence');
        this.setMetaDescription("\n      Romanescu Park Residence este un proiect n\u0103scut din dorin\u021Ba de a oferi craiovenilor toate\n      necesit\u0103\u021Bile unei comunit\u0103\u021Bi urbane moderne \u0219i posibilitatea de a se relaxa c\u00E2t mai aproape de\n      natur\u0103. Unicitatea proiectului este dat\u0103 de loca\u021Bia deosebit\u0103 \u0219i de design-ul simplu \u0219i inteligent\n    ");
    };
    return OurViewComponent;
}(SeoAwareBaseComponent));
export { OurViewComponent };



// WEBPACK FOOTER //
// ./src/app/downtown-life/our-view.component.ts.pre-build-optimizer.js